export const AnalyticsEnum = {
  normal: 'normal',
  records: 'records',
  afterExercise: 'afterExercise',
};
